'use client';

import { useCallback, useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';
import Typography from '@mui/material/Typography';
import { buildImageUrl } from '../../utils/images';
import type { EventFormValues } from './form';
import ImageDropzone from './image-dropzone';

type Props = {
  disabled: boolean;
  forceTouched: boolean;
};

const EventFormImage = ({ disabled }: Props) => {
  const {
    values: { image, currentImage },
    setFieldValue,
  } = useFormikContext<EventFormValues>();

  const filePreviewUrl = useMemo(
    () => (image instanceof File ? URL.createObjectURL(image) : null),
    [image],
  );

  useEffect(() => {
    return () => {
      if (filePreviewUrl) {
        URL.revokeObjectURL(filePreviewUrl);
      }
    };
  }, [filePreviewUrl]);

  const previewUrl =
    filePreviewUrl ??
    (currentImage ? buildImageUrl(currentImage, '400x400iwe') : null);

  const handleFileAccepted = useCallback(
    (file: File) => {
      setFieldValue('image', file);
      if (currentImage) {
        setFieldValue('currentImage', null);
      }
    },
    [setFieldValue, currentImage],
  );

  const handleRemove = useCallback(() => {
    setFieldValue('image', null);
    setFieldValue('currentImage', null);
  }, [setFieldValue]);

  return (
    <>
      <Typography variant="h2">Image</Typography>
      <ImageDropzone
        previewUrl={previewUrl}
        onFileAccepted={handleFileAccepted}
        onRemove={handleRemove}
        disabled={disabled}
      />
    </>
  );
};

export default EventFormImage;
